import {TOKEN, DOWNLOAD_WALLPAPER} from '../vars'
import {setLocalKeyValue, getLocalKeyValue, getJsonData, setJsonData, setSessionKeyValue} from '../storage'
import {GET} from '../helpers'
import FileDownload from '../components/filedownload'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

export default class DownloadButton extends React.Component {
  constructor(props){
    super(props)
    this.state = {submitting:false, failed_status:false}
  }

  download_wallpaper = (wallpaper_id) => {
    let filename = 'picxy_wallpaper_'+wallpaper_id
    let token = getLocalKeyValue(TOKEN)
    if (token) {
      this.setState({submitting:true})
      GET(DOWNLOAD_WALLPAPER + '?wallpaper_id='+wallpaper_id,token,true).then((response) => {
          filename = filename+'.jpg'
          FileDownload(response.data, filename)
          this.setState({submitting:false})
        }).catch((error) => {
          if (error.response.status === 401){
            let ref = "/wallpapers"
            setSessionKeyValue('referer', ref)
            window.location.href="/login"
          }
          else {
            this.setState({submitting:false,failed_status:true})
          }
        })
    }
    else{
      // window.location.href="/login"
      let ref = "/wallpapers"
      setSessionKeyValue('referer', ref)
      window.location.href="/login"

    }
  }

  render() {
    let wallpaper = this.props.wallpaper
    let download_text = "Download"
    let btn_classname = "btn btn-primary active text-center"
    if (this.state.submitting) {
      download_text = "Downloading..."
    }
    else if (this.state.failed_status) {
       download_text = "Something Went Wrong"
       btn_classname = "btn btn-danger text-center"
    }
    return <button type="submit" className={btn_classname} disabled={this.state.submitting} onClick={(e)=>{this.download_wallpaper(wallpaper.id)}}>

      <FontAwesomeIcon icon={faDownload} />
       {download_text}
    </button>
  }
}
